<figure class="mb-5">
  <span
    class="d-inline-block"
    aria-hidden="true"
    [style.background-color]="'var(--mbs-primary)'"
    [style.width.px]="98"
    [style.height.px]="78"
    [style.mask]="'url(' + imagePath[type] + ') no-repeat center / contain'"
    [style.-webkit-mask]="'url(' + imagePath[type] + ') no-repeat center / contain'">
  </span>
</figure>

<h1 class="text-primary mt-0 pb-2 mb-4">{{ getI18NPath('title') | i18next }}</h1>

<div class="container pb-2 mb-4">
  <div class="row justify-content-center">
    <div class="col-2">
      <div class="border-top"></div>
    </div>
  </div>
</div>

<p class="pb-4 mb-4 pre-wrap">
  {{ getI18NPath('description') | i18next }}
</p>

<ng-container *ngIf="type === errorType.Critical">
  <mbs-button
    type="primary"
    (click)="refresh()">
    {{ getI18NPath('action') | i18next: { format: 'title' } }}
  </mbs-button>
</ng-container>

<ng-container *ngIf="type === errorType.NotFound && !hideNotFoundLink">
  <mbs-button
    type="primary"
    (click)="goToDashboardRoute()"
    >{{ getI18NPath('action') | i18next: { format: 'title' } }}
  </mbs-button>
</ng-container>
